import { render, staticRenderFns } from "./screening-questionnaire.vue?vue&type=template&id=71072612&scoped=true"
import script from "./screening-questionnaire.vue?vue&type=script&lang=js"
export * from "./screening-questionnaire.vue?vue&type=script&lang=js"
import style0 from "./screening-questionnaire.vue?vue&type=style&index=0&id=71072612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71072612",
  null
  
)

export default component.exports